import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { GetChatUsersResponse } from "../../Types/Chat";

interface GlobalModalState {
    showDeactivatedModal: boolean;
    showAddPaymentMethodModal: boolean;
    showUnverifiedModal: boolean;
}

const initialState: GlobalModalState = {
    showDeactivatedModal: false,
    showAddPaymentMethodModal: false,
    showUnverifiedModal: false
}

export const globalModalSlice = createSlice({
    name: 'GlobalModal',
    initialState,
    reducers: {
        setShowDeactivatedModal(state, action: PayloadAction<GlobalModalState["showDeactivatedModal"]>){
            state.showDeactivatedModal = action.payload;
        },
        setShowAddPaymentMethodModal(state, action: PayloadAction<GlobalModalState["showAddPaymentMethodModal"]>){
            state.showAddPaymentMethodModal = action.payload;
        },
        setShowUnverifiedModal(state, action: PayloadAction<GlobalModalState["showUnverifiedModal"]>){
            state.showUnverifiedModal = action.payload;
        },
        resetModalSlice: () => initialState
    }
})

export const {
    setShowDeactivatedModal,
    setShowAddPaymentMethodModal,
    setShowUnverifiedModal
} = globalModalSlice.actions

export default globalModalSlice.reducer

